export default __webpack_public_path__ + "static/media/pr_c_27.d7efcd2a.jpg";